<template>
  <div class="divide-y divide-gray-200">
    <qrcode-vue
      :value="qrProps.value"
      :size="qrProps.size"
      :level="qrProps.level"
      renderAs="svg"
      class="mx-auto"
    />
  </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';

export default {
  props: {
    sessionId: {
      type: String,
      required: true,
    },
  },
  components: { QrcodeVue },
  setup(props) {
    const qrProps = {
      value: `{ sessionId: "${props.sessionId}" }`,
      size: 250,
      level: 'L',
      renderAs: 'svg',
    };

    return {
      qrProps,
    };
  },
};
</script>
